import getTabIndex from "../utils/tab-index";

const statusMap = {
    'new': "New",
    'in-progress': "In Progress",
    'resolved': 'Resolved'
};

function getNotes(slide) {
    let slideId = Q3.data.slides[slide].uuid;
    const token = localStorage.getItem("jwt");
    return new Promise(resolve => {
        $.ajax({
            url: `${window.location.origin}${window.COOBO ? "/api" : ""}/slidenotes/${Q3.data._id}/${slideId}`,
            type: 'GET',
            beforeSend: function (request) {
                token && request.setRequestHeader("Authorization", 'Bearer ' + token)
            },
            success: data => {
                resolve(data);
            },
        });
    })
}

function countUnread(slide) {
    return new Promise(resolve => {
        if (!Q3.data.slides[slide]) {
            resolve(0);
            return
        }
        let slideId = Q3.data.slides[slide].uuid;
        const token = localStorage.getItem("jwt");
        $.ajax({
            url: `${window.location.origin}${window.COOBO ? "/api" : ""}/slidenotes/${Q3.data._id}/${slideId}/${Q3.user._id}`,
            type: 'GET',
            beforeSend: function (request) {
                token && request.setRequestHeader("Authorization", 'Bearer ' + token)
            },
            success: data => {
                resolve(data);
            },
        });
    })
}

function markAsRead(slide) {
    let slideId = Q3.data.slides[slide].uuid;
    const token = localStorage.getItem("jwt");
    return new Promise(resolve => {
        $.ajax({
            url: `${window.location.origin}${window.COOBO ? "/api" : ""}/slidenotesmark/${Q3.data._id}/${slideId}/${Q3.user._id}`,
            type: 'GET',
            beforeSend: function (request) {
                token && request.setRequestHeader("Authorization", 'Bearer ' + token)
            },
            success: data => {
                resolve(data);
            },
        });
    })
}

function addNote(slide, noteData) {
    let url = `${window.location.origin}${window.COOBO ? "/api" : ""}/slidenotes`;
    let method = "POST";
    let note = new FormData();
    note.append("text", noteData.text);
    if (Q3.user) {
        note.append("user", Q3.user._id);
        note.append("userName", Q3.user.username);
    }
    if (noteData.replyTo) {
        note.append("replyTo", noteData.replyTo);
    }
    if (noteData.attachments && noteData.attachments.length) {
        noteData.attachments.forEach(f => {
            note.append("attachments", f)
        });
    }
    note.append("demoId", Q3.data._id);
    note.append("slideId", Q3.data.slides[slide].uuid);
    const token = localStorage.getItem("jwt");
    return new Promise(resolve => {
        $.ajax({
            url: url,
            type: method,
            cache: false,
            contentType: false,
            processData: false,
            data: note,
            beforeSend: function (request) {
                token && request.setRequestHeader("Authorization", 'Bearer ' + token)
            },
            success: data => {
                resolve(data);
            },
        });
    })
}

function updateNote(updatedNote) {
    let url = `${window.location.origin}${window.COOBO ? "/api" : ""}/slidenotes/${updatedNote._id}`;
    let method = "PUT";
    const token = localStorage.getItem("jwt");
    return new Promise(resolve => {
        $.ajax({
            url: url,
            type: method,
            data: updatedNote,
            beforeSend: function (request) {
                token && request.setRequestHeader("Authorization", 'Bearer ' + token)
            },
            success: data => {
                resolve(data);
            },
        });
    })
}

function displayDate(date) {
    let d = new Date(date);
    return d.toLocaleDateString() + " " + d.toLocaleTimeString();
}

class SlideNotes {
    constructor() {
        this.text = "";
        this.allNotes = [];
        this.replies = {};
        this.notes = [];
        this.replyingToId = false;
        this.replyingTo = null;
        this.textareaBox = null;
        this.showDeleted = false;
        this.domElement = null;
        this.notesList = null;
        this.attachments = [];
    }

    get() {
        return new Promise((resolve) => {
            $("#notes-spinner").show();
            getNotes(Q3.SlideManager.activeSlide).then((notes) => {
                this.allNotes = notes;
                this.notes = notes.filter(n => !n.replyTo);
                this.replies = notes.filter(n => n.replyTo).reduce((acc, n) => { acc[n.replyTo] = acc[n.replyTo] || []; acc[n.replyTo].push(n); return acc }, {});
                $("#notes-spinner").hide();
                resolve();
            });
        })
    }

    add() {
        $("#notes-spinner").show();
        this.notesAttachments.empty();
        addNote(Q3.SlideManager.activeSlide, { text: this.text, replyTo: this.replyingToId, attachments: this.attachments }).then(() => {
            this.text = "";
            this.attachments = [];
            this.reRenderNotes();
            this.cancelReplying();
            $("#notes-spinner").hide();
        });
    }

    reRenderNotes() {
        this.get().then(() => {
            this.renderNotes()
        });
    }

    changeStatus(note, status) {
        if (status === "undelete") status = "new"
        note.status = status;
        updateNote(note).then(() => {
            this.reRenderNotes();
        });
    }

    renderReplies(id) {
        if (this.replies[id]) {
            return this.replies[id].slice(0).filter(n => {
                return !this.showDeleted && n.status !== "deleted" || this.showDeleted
            }).reverse().map(note => this.renderNote(note))
        } else {
            return [];
        }
    }

    renderNote(note) {
        let $note = $(`<div class="note${note.user._id === Q3.user._id ? " yours" : ""} ${note.status} ${note.replyTo ? "is-reply" : ""}" >
                          <div class="note-text">${note.text}</div>
                          ${note.attachments ? `<div class="note-attachments-list">
                                                    <div><em>Attachments:</em></div>
                                                        ${note.attachments.map(a => `<a href="${Q3.s3Url + a.path}" download="${a.name}">${a.name}</a>`).join("")}
                                                        
                                                    </div>` : ""}
                          <div class="note-meta">
                              <em> by <b class="username">${note.userName}</b> on <b>${displayDate(note.updatedAt)}</b></em>
                          </div>
                      </div>`);
        let del = $(` <div class="note-delete">&times;</div>`);
        del.on("click", () => {
            this.changeStatus(note, "deleted");
        });

        let status = $(`<div class="note-status"></div>`);
        let map = note.replyTo && note.status === "deleted" ? { 'undelete': 'Undelete' } : statusMap;
        Object.keys(map).forEach(s => {
            let newStatus = $(`<span class="change-status status ${s} ${note.status === s ? "active" : ""}"> ${map[s]}</span>`);
            newStatus.on("click", () => {
                this.changeStatus(note, s);
            });
            status.append(newStatus);
        });
        if (!note.replyTo || note.replyTo && note.status === "deleted") {
            $note.append(status);
        }
        if (!note.replyTo) {
            let replyBtn = $(`<div class="reply btn-main">Reply</div>`);
            replyBtn.on("click", () => {
                this.setReplying(note);
            });
            $note.append(replyBtn);
        }
        note.status !== "deleted" && $note.append(del);
        return $note;
    }

    renderNotes() {
        this.notesList.empty();
        if (!this.notesList || !this.notes.length) return;
        let deletedCount = this.allNotes.filter(n => n.status === "deleted").length;
        let showDeleted = $(".notes-container .show-deleted");
        if (deletedCount) {
            showDeleted.show();
        } else {
            $(".notes-container .show-deleted").hide();
            $(".notes-container .show-deleted input[type='checkbox']").prop("checked", false);
            this.showDeleted = false;
        }
        this.notes.filter(n => {
            return !this.showDeleted && n.status !== "deleted" || this.showDeleted
        }).slice(0).reverse().forEach((note) => {
            this.notesList.append(this.renderNote(note), ...this.renderReplies(note._id));
        });
        // this.notesList.html(this.notes.slice(0).reverse().map((note) => `<div
        //                 class="note${note.user._id === Q3.user._id ? " yours" : ""}" >
        //                   <div class="note-text">${note.text}</div>
        //                   <div class="note-meta">
        //                       <em> by <b>${note.user.username}</b> on <b>${displayDate(note.updatedAt)}</b></em>
        //                   </div>
        //               </div>`).join(""))
    }

    removeAttachment(i) {
        this.attachments.splice(i, 1);
        this.renderAttachments();
    }

    addAttachments(e) {
        this.attachments = [...this.attachments, ...Array.from(e.target.files).filter(f => !this.attachments.find(a => a.name === f.name))]
        e.target.value = "";
        this.renderAttachments();
    }

    renderAttachments() {
        this.notesAttachments.empty();
        if (this.attachments.length) {
            this.notesAttachments.html(this.attachments.map((f, i) => `<div>${f.name}<span class="remove-attachment" data-index="${i}"}>&times;</span></div>`).join(""));
            $(".remove-attachment").on("click", (e) => {
                this.removeAttachment($(e.currentTarget).data("index"));
            })
        }
    }

    setReplying(note) {
        this.replyingToId = note._id;
        this.textareaBox.removeClass("add").addClass("reply");
        this.replyingTo.html(`<div style="font-size: 0.75em"><b>Replying to:</b></div><div>${note.text}</div>`);
        this.textarea.attr("placeholder", "Write your reply...");
    }

    cancelReplying() {
        this.replyingToId = false;
        this.textareaBox.removeClass("reply").addClass("add");
        this.replyingTo.html("");
        this.textarea.attr("placeholder", "Add your notes for current slide...");
    }

    init(domElement) {
        if (!domElement || Q3.teachMode) return [];

        let token = localStorage.getItem('jwt');

        if (!token) {
            console.log("SlideNotes: Note Logged In");
            return [];
        }

        let notesWrapper = $(`<div class="notes-container slide-notes-component" style="top: 44px; right: 0; left: auto"></div>`);
        let notesBtn = $(`<p class="material-icons notes-btn show-notes" title="Slide notes" tabindex="${getTabIndex()}"><img src="/images/icons/notes.svg" alt=""></p>`);

        $.ajax({
            url: (window.COOBO ? "/api" : "") + "/demo/user",
            type: 'GET',
            dataType: 'json',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", 'Bearer ' + token)
            },
            success: data => {
                Q3.user = data;

                this.domElement = domElement;

                let notesHeading = $(`<h3 class="notes-heading">Slide ${Q3.SlideManager.activeSlide + 1} notes</h3>`);
                let replyingTo = $(`<div class="replying-to"></div>`);
                this.replyingTo = replyingTo;
                let textareaBox = $(`<div class="textarea-box add"></div>`);
                this.textareaBox = textareaBox;
                let textarea = $(`<textarea placeholder="Add your notes for current slide..."></textarea>`);
                this.textarea = textarea;
                textarea.on("input", (e) => {
                    this.text = e.target.value;
                });

                let notesAttachments = $(`<div class="notes-attachemtns"></div>`);
                this.notesAttachments = notesAttachments;
                let buttons = $(`<div class="d-flex justify-end relative"><div id="notes-spinner" class="spinner-overlay">
                         <span class="waiting-spinner"/>
                     </div></div>`);
                let addAttachment = $(`<label class="notes-add-attachment"><img src="/images/icons/paperclip.svg" alt=""></label>`);
                let attachmentInput = $(`<input type="file" multiple="" id="notes-attachment">`);
                attachmentInput.on("change", (e) => {
                    this.addAttachments(e);
                });
                addAttachment.append(attachmentInput);
                let cancel = $(`<div class="btn-main notes-action cancel" tabindex="${getTabIndex()}">CANCEL</div>`);
                cancel.on("click", () => {
                    this.cancelReplying();
                });
                let addNoteBtn = $(`<div class="btn-main notes-action" tabindex="${getTabIndex()}"><span class="add">ADD NOTE</span><span class="reply">REPLY</span></div>`);
                addNoteBtn.on("click", () => {
                    if (!this.text) return;
                    this.add();
                    textarea[0].value = "";
                });
                buttons.append(addAttachment, cancel, addNoteBtn);
                this.notesList = $(`<div class="notes-list"></div>`);
                let showDeleted = $(`<input type="checkbox" /> `);
                showDeleted.on("input", (e) => {
                    this.showDeleted = $(e.currentTarget).is(":checked");
                    this.reRenderNotes();
                });
                notesWrapper.append(notesHeading, replyingTo, textareaBox.append(textarea, notesAttachments, buttons), this.notesList, $(`<label class="show-deleted">Show deleted?</label>`).append(showDeleted));
                notesWrapper.hide();
                this.domElement.append(notesWrapper);
                notesWrapper.draggable({
                    containment: "#viewer",
                    handle: "h3.notes-heading",
                    scroll: false
                });
                let hideNotes = $(`<p class="material-icons notes-btn hide-notes" title="Hide notes" tabindex="${getTabIndex()}">close</p>`);
                hideNotes.on("click", () => {
                    notesWrapper.fadeOut(200);
                });
                notesWrapper.append(hideNotes);

                let unread = $("<span class='unread-count'></span>");
                const setUnreadCount = () => {
                    countUnread(Q3.SlideManager.activeSlide).then(count => { unread.html(count ? count : "") });
                };
                let showNotes = false;
                notesBtn.on("click", () => {
                    showNotes = !showNotes;
                    showNotes && markAsRead(Q3.SlideManager.activeSlide).then(() => {
                        setUnreadCount();
                    });
                    notesWrapper.fadeToggle(200);
                });
                notesBtn.append(unread);
                $(Q3.container.parentElement).append(notesBtn);
                setUnreadCount();
                Q3.Events.listen("slidechange", () => {
                    notesHeading.html(`Slide ${Q3.SlideManager.activeSlide + 1} notes`);
                    this.reRenderNotes();
                    showNotes ? markAsRead(Q3.SlideManager.activeSlide).then(() => {
                        setUnreadCount();
                    }) : setUnreadCount();
                });
                this.reRenderNotes()

            },
            error: (res, status, err) => {
                console.error(res, status, err);
                console.log("SlideNotes: Note Logged In");
            }
        });

        return [notesWrapper, notesBtn];
    }
}

export default SlideNotes;
export { getNotes, addNote, displayDate, updateNote, countUnread, markAsRead, statusMap }